import { getExperimentById } from 'utils/abTests';

import { ActionType, Experiment, ExperimentsState } from './model';

function getStoredExperiments(): Experiment[] {
  try {
    const parsedExperiments =
      JSON.parse(window.localStorage.getItem('ab-experiments')) || [];
    return parsedExperiments.filter((exp) => {
      const experiment = getExperimentById(exp.id);
      return experiment && experiment.enabled;
    });
  } catch (e) {
    console.error('Error parsing experiments from localStorage', e);
    return [];
  }
}

function storeExperiments(experiments) {
  try {
    window.localStorage.setItem('ab-experiments', JSON.stringify(experiments));
  } catch (e) {
    console.warn('Could not save ab test experiments in localStorage', e);
  }
}

export const initialState: ExperimentsState = {
  experiments: getStoredExperiments(),
};

function reducer(
  state: ExperimentsState,
  action: ActionType,
): ExperimentsState {
  switch (action.type) {
    case 'SET_EXPERIMENT_VARIANT':
      const experiments = [
        ...state.experiments.filter(
          (exp) => exp.id !== action.payload.experimentId,
        ),
        {
          id: action.payload.experimentId,
          assignedVariant: action.payload.variant,
        },
      ];
      storeExperiments(experiments);
      return { ...state, experiments };
  }
}

export default reducer;
